<script setup lang="ts">
defineProps<{ label?: string; hint?: string; error?: string | string[] | null; required?: boolean; inline?: boolean }>();
</script>

<template>
  <div class="field" :class="{ 'field--inline': inline }">
    <div v-if="label" class="field-label">
      {{ label }}<span v-if="required" class="req">*</span>
    </div>
    <div class="field-control"><slot /></div>
    <div v-if="error && (Array.isArray(error) ? error.length : true)" class="field-error">
      {{ Array.isArray(error) ? error[0] : error }}
    </div>
    <div v-else-if="hint" class="field-hint">{{ hint }}</div>
  </div>
</template>

<style scoped>
.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}
.field--inline {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.field-label {
  font-size: 12.5px;
  font-weight: 500;
  color: var(--text-2);
}
.req {
  color: var(--danger);
  margin-left: 2px;
}
.field-hint {
  font-size: 12px;
  color: var(--muted);
}
.field-error {
  font-size: 12px;
  color: var(--danger);
}
</style>
